import { gql } from '@apollo/client';

export const CREATE_CLOUD_ROUTER_MUTATION = gql`
  mutation CreateRouter(
    $input: CreateRouterInput!
    $graphId: ID!
    $name: String!
  ) {
    graph(id: $graphId) {
      id
      variant(name: $name) {
        id
        createRouter(input: $input) {
          ... on CreateRouterSuccess {
            order {
              id
              status
              router {
                id
                endpoints {
                  custom
                  default
                  defaultEnabled
                  primary
                }
                gcus
                nextRouterVersion {
                  core
                }
                nextStatus
                routerVersion {
                  core
                }
                secrets {
                  hash
                  createdAt
                  name
                }
                status
                updatedAt
              }
            }
          }
          ... on InvalidInputErrors {
            errors {
              argument
              location
              reason
            }
            message
          }
          ... on InternalServerError {
            message
          }
        }
      }
    }
  }
`;
